var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';
import { grey } from '@mui/material/colors';
import StickyCommentForm from '../../molecules/StickyCommentForm';
import UnstyledMessage from './Message';
var Message = styled(UnstyledMessage)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n\n  &:first-child {\n    border: none;\n  }\n"], ["\n  border-top: 1px solid ", ";\n\n  &:first-child {\n    border: none;\n  }\n"])), grey[500]);
var MessagesBox = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-height: 100px;\n"], ["\n  min-height: 100px;\n"])));
var ForumMessages = function (_a) {
    var currentUser = _a.currentUser, messages = _a.messages, createMessage = _a.createMessage, deleteMessage = _a.deleteMessage, updateMessage = _a.updateMessage, translateMessage = _a.translateMessage;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(), languagePreference = _c[0], setLanguagePreference = _c[1];
    var _d = React.useState(''), newMessageBody = _d[0], setNewMessageBody = _d[1];
    React.useEffect(function () {
        setLoading(false);
    }, [messages]);
    var handleChange = React.useCallback(function (value) {
        setNewMessageBody(value);
    }, []);
    var addCommentNumberToBody = React.useCallback(function (commentNumber) {
        if (newMessageBody.indexOf(">#".concat(commentNumber)) != -1)
            return;
        setNewMessageBody(">#".concat(commentNumber, "\n") + newMessageBody);
    }, [newMessageBody]);
    return (React.createElement(React.Fragment, null,
        React.createElement(MessagesBox, null,
            messages.map(function (message) { return (React.createElement(Message, { editable: currentUser.role === 'admin' ||
                    currentUser.id === message.author.userId, replyable: currentUser.id !== message.author.userId, message: message, onDelete: function () { return deleteMessage(message.id); }, onUpdateBody: function (updateBody) { return updateMessage(message.id, updateBody); }, languagePreference: languagePreference, translateMessage: function (language) {
                    setLanguagePreference(language);
                    return translateMessage(message.body, language);
                }, onReply: addCommentNumberToBody, key: message.id })); }),
            loading && React.createElement(CircularProgress, null)),
        React.createElement(StickyCommentForm, { disabled: loading, onSubmit: function (submitBody) {
                setLoading(true);
                setNewMessageBody('');
                createMessage({ body: submitBody });
            }, body: newMessageBody, onChange: handleChange, "aria-label": "New Message" })));
};
export default ForumMessages;
var templateObject_1, templateObject_2;
